import Link from "next/link";
import { CONTACT_INFO } from "../_constants/about-constants";
import MailIcon from "@/v2-components/core/icon/mail-icon";
import ExternalLinkIcon from "@/v2-components/core/icon/external-link-icon";
import { useTrans } from "@/utils/useTrans";

interface ContactCardProps {
  title: string;
  subtitle: string;
  href: string;
}

function ContactCard({ title, subtitle, href }: ContactCardProps) {
  return (
    <Link
      href={href}
      className="flex h-36 flex-1 flex-col items-start justify-between rounded-2xl p-5 outline outline-1 outline-offset-[-1px] outline-coolgray-20"
    >
      <div className="flex flex-col items-start justify-start gap-2 self-stretch">
        <div className="text-base">
          {title}
          <br />
          {subtitle}
        </div>
      </div>

      {href.includes("mailto:") ? (
        <MailIcon className="text-blue-60" />
      ) : (
        <ExternalLinkIcon className="text-blue-60" />
      )}
    </Link>
  );
}

export default function ContactSection() {
  const { t } = useTrans(["about", "gnb"]);
  return (
    <div className="flex flex-col items-center justify-center gap-5 self-stretch laptop:gap-8">
      <div className="justify-start self-stretch text-center text-2xl laptop:text-4xl">
        {t(`Join us on the bHaptics journey`)}
      </div>
      <div className="grid w-full gap-5 laptop:grid-cols-3 laptop:gap-6">
        {CONTACT_INFO.map((contact, index) => (
          <ContactCard
            key={index}
            title={t(contact.title)}
            subtitle={t(contact.subtitle)}
            href={contact.href}
          />
        ))}
      </div>
    </div>
  );
}
